import React from "react";
import { partners } from "../mock";

export default function Partners() {
  const list = [...partners, ...partners];
  return (
    <section className="py-20 bg-[#f4ebde] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center mb-10">
        <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#e8a428] mb-3">
          Trusted By
        </p>
        <h3 className="font-serif text-3xl lg:text-4xl text-[#143527]">
          The teams behind hangars, towers and headline events.
        </h3>
      </div>
      <div className="relative">
        <div className="flex marquee-track gap-16 whitespace-nowrap">
          {list.map((p, i) => (
            <span
              key={i}
              className="font-serif text-2xl lg:text-3xl text-[#143527]/55 hover:text-[#143527] transition-colors"
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
